import styled from "styled-components";

import { theme } from "../../themes/themes";
export const List = styled.ul`
  padding-left: 1em;
  width: 345px;
  margin-top: -22px;
  margin-bottom: 0;
  ${(props) => props.OnlyAssigned && `z-index: 2;`}
  ${(props) => props.OnlyAssigned && `background: white;`}
  ${(props) => props.OnlyAssigned && `border-radius: 5px;`}
`;

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-size: 18px;
`;

export const GeneralContainer = styled.div`
  background-color: ${({ theme }) => theme.background.light};
`;

export const ContentWrapper = styled.div`
  margin: 1.5rem;
  width: 96.5%;
  box-shadow: 0px 2px 4px ${({ theme }) => theme.shadows.light};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.neutral.white};
`;
